const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

// Fix for "disclosure.close is not a function" (mobile):
// if details-disclosure.js hasn't loaded when sticky-header
// tries to close menus, provide a safe fallback close().
(function () {
  function fallbackClose() {
    var proto = Object.getPrototypeOf(this);
    if (typeof proto.close === 'function') {
      delete this.close;
      return this.close();
    }
    var details = this.querySelector('details');
    if (details) details.removeAttribute('open');
  }
  function patchAll() {
    document.querySelectorAll('details-disclosure').forEach(function (el) {
      if (typeof el.close !== 'function') el.close = fallbackClose;
    });
  }
  patchAll();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('details-disclosure').then(function () {
      document.querySelectorAll('details-disclosure').forEach(function (el) {
        if (Object.prototype.hasOwnProperty.call(el, 'close')) delete el.close;
      });
    });
  }
})();
